/**
 * It matches any string that contains "safari" but does NOT contain "chrome" or "android" before "safari".
 * This helps distinguish real Safari browsers from Chrome or Android browsers, which also include "Safari" in their user agent string for compatibility.
 * @returns true if is safari browser, false otherwise
 */
export function isSafari() {
  return (typeof navigator !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent));
}
